import axios from 'axios'
const contentType = 'application/json'
const urlJoin = require('url-join')
class ApiBack {
  constructor (authorization) {
    this.authorization = authorization
  }
  /**
   * 获取小区列表
   */
  xqNames () {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/xqNames'),
      data: JSON.stringify({
      })
    })
  }
  /**
   * 查询车辆
   * @param {*} xqName 小区名称
   * @param {*} carNumber 车牌
   * @param {*} roomNo 房号
   * @param {*} pageNum 页
   * @param {*} pageSize 每页数量
   */
  parkLots (xqName, carNumber, roomNo, pageNum, pageSize) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/parkLots'),
      data: JSON.stringify({
        xqName,
        carNumber,
        roomNo,
        pageNum,
        pageSize
      })
    })
  }
  /**
   * 获取在场车辆小区
   */
  carInXQs () {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/carInXQs'),
      data: JSON.stringify({
      })
    })
  }
  /**
   * 获取在场车辆类型
   */
  carTypes () {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/carTypes'),
      data: JSON.stringify({
      })
    })
  }
  /**
   * 进出状态列表
   */
  openGateTypes () {
    return axios({
      method: 'get',
      headers: {
        'Content-Type': contentType
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/openGateTypes'),
      data: JSON.stringify({
      })
    })
  }
  /**
   * 进场状态列表
   */
  openGateInStatus () {
    return axios({
      method: 'get',
      headers: {
        'Content-Type': contentType
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/openGateInStatus'),
      data: JSON.stringify({
      })
    })
  }
  /**
   * 出场状态列表
   */
  openGateOutStatus () {
    return axios({
      method: 'get',
      headers: {
        'Content-Type': contentType
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/openGateOutStatus'),
      data: JSON.stringify({
      })
    })
  }
  /**
   * 场内详情
   * @param {*} xqName 小区名称
   * @param {*} areaId 车库id
   * @param {*} typeVal 车辆类型
   * @param {*} carNumber 车牌
   * @param {*} pageNum 页
   * @param {*} pageSize 每页数量
   * @param {*} inType 入场状态
   */
  carInDetail (xqName, serialNO, areaId, typeVal, carNumber, pageNum, pageSize, inType, payType) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/carInDetail'),
      data: JSON.stringify({
        xqName,
        serialNO,
        areaId,
        typeVal,
        carNumber,
        pageNum,
        pageSize,
        inType,
        payType
      })
    })
  }
  /**
   * 进出场记录
   * @param {*} xqName 小区名
   * @param {*} ioId 通道id
   * @param {*} carNumber 车牌
   * @param {*} inStart 入场开始时间
   * @param {*} inEnd 入场结束时间
   * @param {*} outStart 出场开始时间
   * @param {*} outEnd 出场结束时间
   * @param {*} pageNum 页
   * @param {*} pageSize 每页数量
   * @param {*} inType 入场状态
   * @param {*} outType 出场状态
   * @param {*} carType 车辆类型
   * @param {*} isPay 收费记录
   */
  inAndOutDetail (xqName, carNumber, inStart, serialNO, inEnd, outStart, outEnd, pageNum, pageSize, inType, outType, carType, isPay) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/inAndOutDetail'),
      data: JSON.stringify({
        xqName,
        carNumber,
        serialNO,
        inStart,
        inEnd,
        outStart,
        outEnd,
        pageNum,
        pageSize,
        inType,
        outType,
        carType,
        isPay
      })
    })
  }
  /**
   * 临停缴费查询
   * @param {*} xqName 小区名
   * @param {*} carNumber 车牌
   * @param {*} startTime 开始时间
   * @param {*} endTime 结束时间
   * @param {*} pageNum 页
   * @param {*} pageSize 每页数量
   * @param {*} totalMoney
   */
  chargeInfo (xqName, carNumber, startTime, endTime, pageNum, pageSize, totalMoney) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/chargeInfo'),
      data: JSON.stringify({
        xqName,
        carNumber,
        startTime,
        endTime,
        pageNum,
        pageSize,
        totalMoney
      })
    })
  }
  /**
   * 小区通道列表
   */
  ioInfo () {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/ioInfo'),
      data: JSON.stringify({
      })
    })
  }
  /**
   * 异常放行记录
   * @param {*} xqName 小区名
   * @param {*} carNumber 车牌
   * @param {*} ioId 通道id
   * @param {*} pageNum 页
   * @param {*} pageSize 每页数量
   * @param {*} type 类型
   * @param {*} inStart
   * @param {*} inEnd
   */
  abnormalInfo (xqName, carNumber, ioId, pageNum, pageSize, type, inStart, inEnd) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/abnormalInfo'),
      data: JSON.stringify({
        xqName,
        carNumber,
        ioId,
        pageNum,
        pageSize,
        type,
        inStart,
        inEnd
      })
    })
  }
  login (userName, password, token) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'login/userInfo'),
      data: JSON.stringify({
        userName,
        password,
        token
      })
    })
  }
  loginOut () {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'login/loginOut'),
      data: JSON.stringify({})
    })
  }
  index () {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'login/indexInfo'),
      data: JSON.stringify({})
    })
  }
  queryArea (xqName) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/queryArea/xqName'),
      data: JSON.stringify({
        xqName
      })
    })
  }
  addSystemSetInformation (data) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/addSystemSetInformation'),
      data: JSON.stringify(data)
    })
  }
  queryModel (xqName, modelType) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/queryModel/xqName'),
      data: JSON.stringify({
        xqName,
        modelType
      })
    })
  }
  addModelRule (data) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/addModelRule'),
      data: JSON.stringify(data)
    })
  }
  getAreaInfoByXQ (xqName) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/area/getAreaInfoByXQ'),
      data: JSON.stringify({
        xqName
      })
    })
  }
  delGarage (areaId) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/area/delGarage'),
      data: JSON.stringify({
        areaId
      })
    })
  }
  editGarage (areaId, areaName, xqName, remark) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/area/editGarage'),
      data: JSON.stringify({
        areaId,
        areaName,
        xqName,
        remark
      })
    })
  }
  addGarage (areaName, xqName, remark) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/area/addGarage'),
      data: JSON.stringify({
        areaName,
        xqName,
        remark
      })
    })
  }
  queryIoInformation (xqName, pageNum, pageSize) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/queryIoInformation/xqName'),
      data: JSON.stringify({
        xqName,
        pageNum,
        pageSize
      })
    })
  }
  changeStopStatus (data) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/changeStopStatus'),
      data: JSON.stringify(data)
    })
  }
  deleteIoInformation (data) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/deleteIoInformation'),
      data: JSON.stringify(data)
    })
  }
  addIoInformation (data) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/addIoInformation'),
      data: JSON.stringify(data)
    })
  }
  doCarQCode (ioid) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/doCarQCode'),
      data: JSON.stringify({
        ioid
      })
    })
  }
  doVolume (serialNO, volumeVal, xqName) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/doVolume'),
      data: JSON.stringify({
        serialNO,
        volumeVal,
        xqName
      })
    })
  }
  clearCache () {
    return axios({
      method: 'get',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'clearCache'),
      data: JSON.stringify({})
    })
  }
  queryWrongInformation (xqName, carNumber, count, pageNum, pageSize) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/queryWrongInformation'),
      data: JSON.stringify({
        xqName,
        carNumber,
        count,
        pageNum,
        pageSize
      })
    })
  }
  queryMoreInformation (xqName, carNumber, pageNum, pageSize) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/queryMoreInformation'),
      data: JSON.stringify({
        xqName,
        carNumber,
        pageNum,
        pageSize
      })
    })
  }
  addBlackList (xqName, blackUser, carNumber) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/addBlackList'),
      data: JSON.stringify({
        xqName,
        blackUser,
        carNumber
      })
    })
  }
  deleteBlackList (xqName, blackUser, carNumber) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/deleteBlackList'),
      data: JSON.stringify({
        xqName,
        blackUser,
        carNumber
      })
    })
  }
  getUserInfo (xqName, pageNum, pageSize) {
    return axios({
      method: 'get',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/getUserInfo'),
      params: {
        xqName,
        pageNum,
        pageSize
      }
    })
  }
  getRoles () {
    return axios({
      method: 'get',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/getRoles'),
      params: {}
    })
  }
  addUser (xqname, roles, oname, opassword, realName, phoneNumber, ioInfoList) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/addUser'),
      params: {},
      data: JSON.stringify({
        xqname,
        roles,
        oname,
        opassword,
        realName,
        phoneNumber,
        ioInfoList
      })
    })
  }
  updateUser (oid, roles, oname, opassword, realName, phoneNumber, ioInfoList) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/updateUser'),
      params: {},
      data: JSON.stringify({
        oid,
        roles,
        oname,
        opassword,
        realName,
        phoneNumber,
        ioInfoList
      })
    })
  }
  delUser (oid) {
    return axios({
      method: 'get',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/delUser'),
      params: {
        oid
      }
    })
  }
  removeOneCar (cid, uName) {
    return axios({
      method: 'get',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/removeOneCar'),
      params: {
        cid,
        uName
      }
    })
  }
  addCar (carNumber, czName, czPhone, xqName, houseName) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/addCar'),
      data: {
        carNumber,
        czName,
        czPhone,
        xqName,
        houseName
      }
    })
  }
  /**
   * 获取idoru小区列表
   * @param {*} xqName 小区名
   */
  getIdoruXQList () {
    return axios({
      method: 'get',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/getIdoruXQList'),
      data: {}
    })
  }

  /**
   * 车库列表
   * @param {*} xqName 小区名称
   */
  areaList (xqName) {
    return axios({
      method: 'get',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/areaList'),
      params: {
        xqName
      }
    })
  }
  /**
   * 车位列表
   * @param {*} areaId 车库id
   */
  parkSpaceList (areaId) {
    return axios({
      method: 'get',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/parkSpaceList'),
      params: {
        areaId
      }
    })
  }
  checkSpace (areaId, garageNo) {
    return axios({
      method: 'get',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/checkSpace'),
      params: {
        areaId,
        garageNo
      }
    })
  }
  checkSpaceDate (areaId, garageNo, beginDate, endDate, xqName, spaceId) {
    return axios({
      method: 'get',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/checkSpaceDate'),
      params: {
        areaId,
        garageNo,
        beginDate,
        endDate,
        xqName,
        spaceId
      }
    })
  }
  addParkSpace (xqName, roomNo, spaceList, carList, ownerId) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/addParkSpace'),
      data: {
        xqName,
        roomNo,
        spaceList,
        carList,
        ownerId
      }
    })
  }
  userCarList (carNumber, xqName) {
    return axios({
      method: 'get',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/userCarList'),
      params: {
        carNumber,
        xqName
      }
    })
  }
  checkCar (carNumber, xqName, cid) {
    return axios({
      method: 'get',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/checkCar'),
      params: {
        carNumber,
        xqName,
        cid
      }
    })
  }
  syncParkLot (xqName) {
    return axios({
      method: 'get',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/syncParkLot'),
      params: {
        xqName
      }
    })
  }
  xqOff (xqName) {
    return axios({
      method: 'get',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/xqOff'),
      params: {
        xqName
      }
    })
  }
  delset (ownerId) {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': contentType,
        'Authorization': this.authorization
      },
      url: urlJoin(process.env.VUE_APP_API_URL, 'backQuery/delParkSpace'),
      data: {
        ownerId
      }
    })
  }
}

export {
  ApiBack
}
